import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { COLLECTION_CARDS } from "@/config/site";

const spanCls = {
    lg: "md:col-span-6 lg:col-span-6 aspect-[16/10]",
    md: "md:col-span-3 lg:col-span-3 aspect-[3/4] md:aspect-[4/5]",
    sm: "md:col-span-3 lg:col-span-3 aspect-[3/4] md:aspect-[4/5]",
};

const FeaturedCollections = () => (
    <section className="py-24 sm:py-36 bg-charcoal/30" data-testid="featured-collections">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
            <SectionHeading
                eyebrow="The Collections"
                title={<>Explore Our <span className="italic gold-text">Collections</span></>}
                copy="Ten worlds of gold, diamond and bridal jewellery — each curated for the moments that matter."
            />
            <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-5 lg:gap-6">
                {COLLECTION_CARDS.map((c, i) => (
                    <Reveal key={c.name} delay={(i % 4) * 0.08} className={c.span === "lg" ? "md:col-span-6" : "md:col-span-3"}>
                        <Link
                            to={c.to}
                            data-testid={`collection-card-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className="group relative block overflow-hidden border border-gold/10 hover:border-gold/50 transition-colors duration-500"
                        >
                            <div className={`${spanCls[c.span]} overflow-hidden`}>
                                <img
                                    src={c.image}
                                    alt={`${c.name} — BSK Jewellers Amritsar`}
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-[1.08]"
                                />
                            </div>
                            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/95 via-obsidian/30 to-transparent" />
                            <div className="absolute bottom-0 inset-x-0 p-6 sm:p-7">
                                <h3 className="font-serif text-2xl sm:text-3xl text-ivory group-hover:text-gold transition-colors duration-500">{c.name}</h3>
                                <p className="text-xs sm:text-sm text-sand mt-1.5 max-w-xs leading-relaxed opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                                    {c.desc}
                                </p>
                                <span className="inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-gold mt-4">
                                    Explore Collection <ArrowRight size={12} className="group-hover:translate-x-1.5 transition-transform duration-300" />
                                </span>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default FeaturedCollections;
